import { Badge, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const stationPlans = [
  {
    id: "market-radar",
    title: "Market Radar",
    subtitle: "Monitoreo automático de precios de rivales",
    price: 299,
    unit: "usd / mes",
    accent: "primary",
    features: [
      "Historial de precios por rival",
      "Hasta 7 rivales",
      "Máximos / mínimos / promedios",
      "Alertas de cambios de precio (email)",
      "Compara con tus competidores",
      "1 estación",
    ],
  },
  {
    id: "profit-optimizer",
    title: "Profit Optimizer",
    subtitle: "Maximiza utilidad con datos reales",
    price: 899,
    unit: "usd / mes",
    accent: "success",
    badge: "Recomendado",
    features: [
      "Market Radar",
      "+ Alertas por whatsapp",
      "Carga de ventas (control volumetrico)",
      "Cálculo de precio óptimo",
      "Vista calendario de resultados",
      "Dashboard financiero",
      "1 estación",
    ],
  },
  {
    id: "enterprise",
    title: "Enterprise",
    subtitle: "Custom pricing para volumen alto de estaciones",
    price: "",
    unit: "Hablemos",
    accent: "dark",
    badge: "Alto volumen",
    features: [
      "Descuentos por volumen de estaciones",
      "Onboarding dedicado y soporte prioritario",
      "Capacitaciones para tu equipo",
      "Opciones de facturación a medida",
    ],
  },
];

const StationPlans = () => {
  return (
    <section className="py-lg-12 py-8 bg-white">
      <Container>
        <Row className="mb-6">
          <Col lg={8} md={12} sm={12}>
            <span className="text-uppercase text-primary fw-bold small">
              Planes para estaciones
            </span>
            <h2 className="display-5 fw-bold mb-3">Pricing diseñado para aumentar tu utilidad</h2>
            <p className="lead text-muted mb-0">
              Nuestros planes están pensados para gasolineras que quieren dejar de adivinar precios
              y empezar a maximizar su margen. En la práctica, nuestros clientes suelen recuperar la
              inversión en días, no en meses.
            </p>
          </Col>
        </Row>
        <Row>
          {stationPlans.map((plan) => (
            <Col lg={4} md={6} sm={12} className="mb-4" key={plan.id}>
              <Card className="h-100 shadow-sm">
                <Card.Body className="p-5 d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-start mb-4">
                    <div>
                      <h3 className="mb-1">{plan.title}</h3>
                      <p className="text-muted mb-0">{plan.subtitle}</p>
                    </div>
                    {plan.badge && (
                      <Badge bg={plan.accent || "primary"} pill>
                        {plan.badge}
                      </Badge>
                    )}
                  </div>
                  <div className="d-flex align-items-baseline mb-4">
                    <span className="h1 fw-bold mb-0">${plan.price}</span>
                    <span className="text-muted ms-2">{plan.unit}</span>
                  </div>
                  <ListGroup bsPrefix="list-unstyled" className="mb-4">
                    {plan.features.map((feature, idx) => (
                      <ListGroup.Item key={idx} bsPrefix="list-item" className="mb-2">
                        <span className="text-success me-2">
                          <i className="far fa-check-circle"></i>
                        </span>
                        <span>{feature}</span>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                  <div className="mt-auto d-grid">
                    <Link
                      to="https://wa.me/528114706347"
                      target="__blank"
                      className={`btn btn-${plan.accent || "primary"}`}
                    >
                      Quiero este plan
                    </Link>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StationPlans;
